var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"highlight-text"},_vm._l((_vm.tokens),function(token,index){return _c('span',{key:index,class:token[0]},[_vm._v(_vm._s(token[1]))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }